import { createAction, createSlice } from '@reduxjs/toolkit';

import { STATUS } from '@constants/status';
import { type SagaConfig } from '@sagas/request/types';

import type { UserState, UserUpdateRequest, UserUpdateRoleRequest } from './types';

export const initialState: UserState = {
  model: {},
  meta: {
    errorMessage: '',
    status: STATUS.LOADING,
  },
};

export const userRequest = createAction<{ userId: string; sagaConfig?: SagaConfig }>(
  'user/request'
);

export const userUpdateRequest = createAction<UserUpdateRequest>('user/updateRequest');
export const userUpdateRoleRequest = createAction<UserUpdateRoleRequest>('user/updateRoleRequest');

const user = createSlice({
  name: 'user',
  initialState,
  reducers: {
    reset: () => initialState,
    success: (state, action) => {
      state.meta.status = STATUS.SUCCESS;
      state.model = action.payload.result;
    },
    failure: (state, action) => {
      state.meta.status = STATUS.ERROR;
      state.meta.errorMessage = action.payload.errorMessage;
    },
    updateSuccess: (state, action) => {
      state.meta.status = STATUS.SUCCESS;
      state.model = {
        ...state.model,
        ...action.payload.result,
      };
    },
    updateFailure: state => {
      state.meta.status = STATUS.ERROR;
    },
  },
  extraReducers: builder => {
    builder.addCase(userRequest.type, state => {
      state.meta.errorMessage = '';
      state.meta.status = STATUS.LOADING;
    });
    builder.addCase(userUpdateRequest.type, state => {
      state.meta.errorMessage = '';
      state.meta.status = STATUS.UPDATING;
    });
  },
});

export const {
  reset: userReset,
  success: userSuccess,
  failure: userFailure,
  updateSuccess: userUpdateSuccess,
  updateFailure: userUpdateFailure,
} = user.actions;

export default user.reducer;
